import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 24,
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: theme.spacing(1.5),
  },
  message: {
    fontSize: 14,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
